const routes = [
  {
    path: '/webChat',
    name: 'webchatIndex',
    component: () => import(/* webpackChunkName: "webChat" */ '../views/webChat/WebChat.vue'),
    meta: {
      requireAuth: true,
      pageIndex: 1,
      headerControler: {
        back: false,
        history: true,
        hidden: true
      }
    }
  },
  {
    path: '/webChat/history',
    name: 'history',
    meta: {
      requiresAuth: true,
      pageIndex: 2,
      headerControler: {
        back: true,
        history: false,
        hidden: true
      }
    },
    component: () => import(/* webpackChunkName: "History" */ '../views/webChat/History.vue')
  },
  {
    path: '/webChat/historyDetail',
    name: 'historyDetail',
    meta: {
      requiresAuth: true,
      pageIndex: 3,
      headerControler: {
        back: true,
        history: false,
        hidden: true
      }
    },
    component: () => import(/* webpackChunkName: "HistoryDetail" */ '../views/webChat/HistoryDetail.vue')
  },
  {
    path: '/history/list',
    name: 'history',
    meta: {
      requiresAuth: true,
      pageIndex: 1,
      headerControler: {
        back: false,
        history: false,
        hidden: true
      }
    },
    component: () => import(/* webpackChunkName: "HistoryList" */ '../views/history/List.vue')
  },
  {
    path: '/history/detail',
    name: 'history_detail',
    meta: {
      requiresAuth: true,
      pageIndex: 2,
      headerControler: {
        back: false,
        history: false,
        hidden: true
      }
    },
    component: () => import(/* webpackChunkName: "HistoryListDetail" */ '../views/history/Detail.vue')
  },
  {
    path: '/notFound',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue'),
    meta: {
      requireAuth: false,
      headerControler: {
        back: false,
        history: false,
        hidden: true
      }
    }
  },
  {
    path: '/kakao/chat/open',
    name: 'kakaoChatOpen',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "kakaoChatOpen" */ '@/views/webChat/components/CreateChannelButton')
  },
  {
    path: '/naver/chat/open',
    name: 'naverChatOpen',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "naverChatOpen" */ '@/views/webChat/components/NaverChatOpen'),
    props: (route) => ({
      naverTalkId: route.query.naverTalkId,
      chatRoomId: route.query.chatRoomId
    })
  },
  {
    path: '/video/chat/open',
    name: 'videoOpen',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "VideoOpen" */ '@/views/webChat/components/VideoOpen')
  },
  // 이용 약관 안내
  {
    path: '/introduction/auth_notice',
    name: 'authNotice',
    component: () => import(/* webpackChunkName: "authNotice" */ '@/views/webChat/components/notice/customer_authentication_notice')
  },

  // 헥토이노베이션 커스텀 start
  {
    path: '/hecto/webChat',
    name: 'webchatIndexHecto',
    component: () => import(/* webpackChunkName: "webChatForHecto" */ '../views/webChat/WebChatForHecto'),
    meta: {
      requireAuth: true,
      pageIndex: 1,
      headerControler: {
        back: false,
        history: true,
        hidden: true
      }
    }
  },
  {
    path: '/hecto/introduction/auth_notice',
    name: 'authNoticeHecto',
    component: () =>
      import(/* webpackChunkName: "authNoticeForHecto" */ '@/views/webChat/components/notice/custom/hecto/customer_authentication_notice_for_hecto')
  },
  // 헥토이노베이션 커스텀 end

  {
    path: '*', // 2.x: path:'*' -> 3.x: path: '/:catchAll(.*)'
    redirect: '/notFound'
  }
];

export default routes;
